export default __webpack_public_path__ + "static/media/icon-user-white.083490fc.svg";